var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:({ height: _vm.size, width: _vm.size, borderTopColor: _vm.color  })})
}
var staticRenderFns = []

export { render, staticRenderFns }